import React, { useEffect, useState } from "react";
import styles from "./CartInformationCompleted.module.css";
import PropTypes from "prop-types";

import Label from "shared/components/Label";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import toVND from "shared/func/toVND";
import {
  LOCAL_STORAGE_CARTS,
  LOCAL_STORAGE_INFORMATION_CART,
  PAYMENT_METHOD,
} from "../../../shared/Constants";
import { useDispatch } from "react-redux";
import { fetchFeeShipRequest } from "redux/ActionCreators/PaymentActionCreator";

const CartInformationCompleted = (props) => {
  const { handelDataSubmit } = props;

  const dispatch = useDispatch();

  const [
    cartInformationInLocalStorage,
    setCartInformationInLocalStorage,
  ] = useState(
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_INFORMATION_CART))
  );

  const [cartsInLocalStorage, setCartsInLocalStorage] = useState(
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_CARTS))
  );

  useEffect(() => {
    if (
      cartInformationInLocalStorage &&
      cartsInLocalStorage &&
      cartsInLocalStorage.length
    ) {
      const { city, district } = cartInformationInLocalStorage;
      let sum = 0;
      cartsInLocalStorage.forEach((item, index) => {
        sum += item.count * item.priceDiscount;
      });

      dispatch(fetchFeeShipRequest(city.name, district.name, 100, sum));
    }
  }, []);

  const handelSubmit = () => {
    handelDataSubmit(cartsInLocalStorage, cartInformationInLocalStorage);
  };

  if (
    !cartInformationInLocalStorage ||
    !cartsInLocalStorage ||
    !cartsInLocalStorage.length
  )
    return <div>Loading...</div>;
  return (
    <div>
      <div className={styles.item} style={{ textTransform: "capitalize" }}>
        <Label
          title="Họ tên:"
          content={`${cartInformationInLocalStorage.firstName} ${cartInformationInLocalStorage.lastName}`}
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label
          title="Email:"
          content={`${cartInformationInLocalStorage.email}`}
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label
          title="Số điện thoại:"
          content={`${cartInformationInLocalStorage.phoneNumber}`}
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label
          title="Địa chỉ:"
          content={`${cartInformationInLocalStorage.ward.name} 
         - ${cartInformationInLocalStorage.district.name}
          - ${cartInformationInLocalStorage.city.name}`}
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label
          title="Địa chỉ chi tiết:"
          content={`${cartInformationInLocalStorage.addressDetail}`}
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label
          title="Hình thức thanh toán:"
          content={
            PAYMENT_METHOD.find((item) => {
              return item.key === cartInformationInLocalStorage.paymentMethod;
            }).name
          }
        />
        <Divider />
      </div>

      <div className={styles.item}>
        <Label title="Sản phẩm:" content="" />
        <span>
          {cartsInLocalStorage.map((item, index) => (
            <CartInformationProducts data={item} key={index} />
          ))}
        </span>
        <Divider />
      </div>

      <div className={styles.btn_submit}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handelSubmit}
        >
          Thanh Toán & Đặt Hàng
        </Button>
      </div>
    </div>
  );
};

const CartInformationProducts = ({ data }) => {
  const { imgPath, title, priceDiscount, count } = data;
  return (
    <Grid container spacing={3} style={{ marginTop: "10px" }}>
      <Grid item xs={3} sm={1}>
        <img src={imgPath} alt="not found..." />
      </Grid>
      <Grid item xs={5} sm={3}>
        <Typography variant="body1" gutterBottom>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={1} sm={1}>
        <Typography variant="body1" gutterBottom>
          {count} SL
        </Typography>
      </Grid>

      <Grid item xs={2} sm={2}>
        <Typography variant="subtitle2" gutterBottom>
          {toVND(count * priceDiscount)}
        </Typography>
      </Grid>
    </Grid>
  );
};

CartInformationCompleted.propTypes = {
  handelDataSubmit: PropTypes.func,
};

export default CartInformationCompleted;
